var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5471 0C4.90321 0 0.341187 4.47 0.341187 10C0.341187 15.53 4.90321 20 10.5471 20C16.1909 20 20.7529 15.53 20.7529 10C20.7529 4.47 16.1909 0 10.5471 0ZM10.5471 8.59L14.211 5L15.65 6.41L11.9861 10L15.65 13.59L14.211 15L10.5471 11.41L6.88315 15L5.44412 13.59L9.10803 10L5.44412 6.41L6.88315 5L10.5471 8.59Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear-icon.8496fac22acfed297a10f3bb5a789975.svg";
export { ForwardRef as ReactComponent };